/**
 * @autoor 80004302
 * @desc 页面头部的下拉菜单配置项及分类菜单显示
 * @desc 配置规则： 有path项，直接跳转链接（要判断链接还是路由）； code配置项为详情页（即菜单项的叶子节点）通过detail/code路由跳转
 */
import expressRouter from './express'
import serviceRouter from './service'
import {getURLWithContext, getDynamicURLWithContext, getDynamicURLWithContextNew} from '@/util/util'
const home = {
    name: '首页',
    path:  getDynamicURLWithContext('index.html'),
}
const express = {
    name: '快递产品',
    path: 'product/list?type=express',
    children: expressRouter.children
}
const service = {
    name: '增值服务',
    path: 'service',
    children: serviceRouter.children
}
const financial = {
    name: '金融',
    path: 'https://www.sf-financial.com/sfjrpc/?fc=ex&fp=nt&fa=pc&',
}
const bussiness = {
    name: '商业',
    path: '',
}
const cases = {
    name: '成功案例',
    path: '',
}
const support = {
    name: '服务支持',
    path: '',
}
const partnership = {
    name: '顺丰控股投资者关系',
    path: '',
}
const about = {
    name: '关于我们',
    path: '',
}
const region = {
    name: '选择国家或地区',
    path: '',
}

export default {
    name: 'root',                                   // 顶级菜单
    children: [
        home,                                       // 首页
        express,                                    // 快递产品
        service,                                    // 增值服务
        financial,                                  // 金融
        bussiness,                                  // 商业
        cases,                                      // 成功案例
        support,                                    // 支持服务
        partnership,                                // 投资者关系
        about,                                      // 关于我们
        region,                                     // 区域选择        
    ]
}


// WEBPACK FOOTER //
// ./src/components/header/menuConfig/index.js